export default __webpack_public_path__ + "4f1f1928a7cea5a5ad9fd3144824626b.png";